import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const Content = styled.div`
    &.Especial{  
        width: 100vw;
        left: 50%;
        position: relative;
        transform: translateX(-50%);
        ${breakpoints.phone} {
            display: block;
        }
    }
`;